import React, { MouseEventHandler } from "react";

import { Grid, Button, Link as MuiLink, CircularProgress } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { Link, LinkProps } from "react-router-dom";

import { OnboardingInfoBoxProps, OnboardingInfoBox } from "./OnboardingInfoBox";

const useStyles = makeStyles()((theme) => ({
  main: {
    gridRow: "1 / span 3",
    backgroundImage: theme.palette.backgrounds.pageGradient,
    padding: theme.spacing(5, 4),
    overflowY: "scroll",

    "& > .MuiGrid-item:not(:first-child)": {
      marginTop: theme.spacing(4),
    },

    "& a": {
      marginTop: theme.spacing(2),
      textAlign: "center",
    },
  },
}));

export const ScreenFrame = ({
  body,
  buttonText,
  children,
  link,
  onClick,
  title,
  variant,
  anchorText,
  loading,
  disabled,
}: ScreenFrameProps) => {
  const { classes } = useStyles();

  return (
    <Grid item container className={classes.main}>
      <Grid item container>
        <OnboardingInfoBox title={title} body={body} variant={variant} />
      </Grid>
      {children && <Grid item container direction="column">{children}</Grid>}
      <Grid item container justifyContent="center" direction="column">
        <Button
          color="primary"
          variant="contained"
          onClick={onClick}
          disabled={disabled}
        >
          {loading ? (
            <CircularProgress color="inherit" size={30} />
          ) : (
            buttonText
          )}
        </Button>

        {link && (
          <MuiLink
            color="primary"
            component={Link}
            to={link}
            underline="always"
            variant="body1"
          >
            {anchorText || "Pular"}
          </MuiLink>
        )}
      </Grid>
    </Grid>
  );
};

export type ScreenFrameProps = OnboardingInfoBoxProps & {
  /** Text shown inside buton */
  buttonText: string;
  /** Path to navigate when skipping, anything provided here will be passed down to <Link to={link} /> */
  link?: LinkProps["to"];
  onClick: MouseEventHandler<HTMLButtonElement>;
  children?: any; //TODO - check the types
  anchorText?: string;
  /** text to show in the second button */
  loading?: boolean;
  /** enable to show circular loading */
  disabled?: boolean;
  /** true to disable */
};
